var AnalyticsService       = require("app/Analytics/AnalyticsService"),
    AppLayoutView          = require("app/AppLayout/LayoutView"),
    AppState               = require("app/AppState/AppState"),
    AuthService            = require("app/Auth/AuthService"),
    AutoplayTimerService   = require("app/AutoplayTimer/AutoplayTimerService"),
    BookmarkService        = require("app/Bookmarks/BookmarkService"),
    ContinueSignUpPopup    = require("app/Auth/ContinueSignUpPopup"),
    Control                = require("enyo/Control"),
    CoreApp                = require("app/core/App"),
    CountdownService       = require("app/clock/CountdownService"),
    FotocadeauService      = require("app/Fotocadeau/FotocadeauService"),
    HeaderController       = require("app/AppHeader/HeaderController"),
    I18nService            = require("app/i18n/I18nService"),
    InstallPromptService   = require("app/PWA/NativeInstallPromptService"),
    IsAdultPopup           = require("app/Auth/IsAdultPopup"),
    L10nService            = require("app/l10n/L10nService"),
    MediaPlayerController  = require("app/MediaPlayer/MediaPlayerController"),
    MediaPlayerManager     = require("app/core/MediaPlayerManager"),
    PrivacyService         = require("app/ConsentManagement/PrivacyService"),
    SentryIOService        = require("app/Sentry/SentryIOService"),
    Signals                = require("enyo/Signals"),
    WatchingSessionService = require("app/WatchingSession/WatchingSessionService"),
    config                 = require("app/config"),
    domain                 = [].concat(
        require("app/Domain/Ott/Api/V2/DataAccess/Artist/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Audio/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Book/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Brand/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Category/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Dashboard/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/L10n/Service"),
        require("app/Domain/Ott/Api/V2/DataAccess/Magazine/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Media/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/MusicAlbum/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Offer/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Page/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Playlist/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Podcast/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Product/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/ProductCategory/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/Series/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/User/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/User/Service"),
        require("app/Domain/Ott/Api/V2/DataAccess/UserPayments/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/UserSession/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/UserSession/Service"),
        require("app/Domain/Ott/Api/V2/DataAccess/UserSubscription/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/UserSubscription/Service"),
        require("app/Domain/Ott/Api/V2/DataAccess/Video/Repository"),
        require("app/Domain/Ott/Api/V2/DataAccess/WatchingSession/Service")
    ),
    get                    = require("object-path").get,
    isIosApp               = require("app/utils/isIosApp"),
    kind                   = require("enyo/kind"),
    logger                 = require("enyo/logger"),
    quickMacroize          = require("enyo/macroize").quickMacroize,
    routes                 = [].concat(
        require("app/ArtistPage/routes"),
        require("app/AudioPage/routes"),
        require("app/BookPage/routes"),
        get(config, "bookmarks.enabled", false)
            ? require("app/BookmarkPage/routes")
            : [],
        require("app/BrandPage/routes"),
        require("app/CategoryPage/routes"),
        require("app/ForgotPasswordPage/routes"),
        get(config, "login.enabled", false)
            ? require("app/LoginPage/routes")
            : [],
        get(config, "login.enabled", false)
            ? require("app/LogoutPage/routes")
            : [],
        require("app/MagazinePage/routes"),
        require("app/MediaPlayer/routes"),
        require("app/MusicAlbumPage/routes"),
        require("app/OopsPage/routes"),
        require("app/PagePage/routes"),
        require("app/PlaylistPage/routes"),
        require("app/PodcastPage/routes"),
        require("app/ProductCategoryPage/routes"),
        require("app/ProductPage/routes"),
        require("app/ProfilePage/routes"),
        require("app/SearchPage/routes"),
        require("app/SeriesPage/routes"),
        require("app/UpgradeRequiredPage/routes"),
        require("app/UserRequiredPage/routes"),
        require("app/VideoPage/routes"),

        // Home page routes come last, because the catch-all routes are in here
        // too.
        require("app/HomePage/routes")
    ),
    serviceWorkerRuntime   = require("serviceworker-webpack-plugin/lib/runtime"),
    themeVars              = require("app/theme/variables.js");

require("app/theme/theme.less");

module.exports = kind(/** @lends  app.App.prototype */ {

    /**
     * @private
     */
    name: "app.core.App",

    /**
     * @private
     */
    kind: CoreApp,

    /**
     * @private
     */
    view: AppLayoutView,

    /**
     * The application startup status. Status can have the following values:
     *  - `-1` = not started
     *  - `0` = currently being started
     *  - `1` = started
     *
     * @type     {Number}
     * @default  0
     * @readonly
     * @public
     */
    started: -1,

    /**
     * Components that will not be generating any of the UI. These get
     * initialized before the view.
     *
     * @private
     */
    components: [{
        kind:    Signals,
        onkeyup: "handleKeyUp"
    }, {
        name: "state",
        kind: AppState
    }, {
        name: "i18nService",
        kind: I18nService
    }, {
        name: "l10nService",
        kind: L10nService
    }, {
        name: "authService",
        kind: AuthService
    }, {
        name: "privacyService",
        kind: PrivacyService
    }, {
        name: "sentryIOService",
        kind: SentryIOService
    }, {
        name: "analyticsService",
        kind: AnalyticsService
    }, {
        name:                      "mediaPlayerManager",
        kind:                      MediaPlayerManager,
        mediaPlayerControllerKind: MediaPlayerController
    }, {
        name: "watchingSessionService",
        kind: WatchingSessionService
    }, {
        name: "autoplayTimerService",
        kind: AutoplayTimerService
    }, {
        name: "bookmarkService",
        kind: BookmarkService
    }, {
        name: "installPromptService",
        kind: InstallPromptService
    }, {
        name: "countdownService",
        kind: CountdownService
    }, {
        name: "fotocadeauService",
        kind: FotocadeauService
    }],

    /**
     * Components that will be generating parts of the UI. These will be
     * initialized after the view.
     *
     * @private
     */
    UiComponents: [{
        name: "header",
        kind: HeaderController
    }, {
        name:        "continueSignUpPopup",
        kind:        ContinueSignUpPopup,
        canGenerate: false
    }, {
        name:        "isAdultPopup",
        kind:        IsAdultPopup,
        canGenerate: false
    }],

    /**
     * @private
     */
    handlers: {
        onresize: "handleResize"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            var $router;

            sup.apply(this, arguments);

            // The final bits of bootstrapping before we start the application
            this.refreshHeader = this.bindSafely(this.refreshHeader);
            $router            = this.$.router;
            $router.set("root", config.rootPath);
            $router.setDefaultPath(this.bindSafely(function(params) {
                params = params || {};

                return quickMacroize("/{$language}/home", {
                    language: params.language || this.$.i18nService.get("language")
                });
            }));
            themeVars.reflow();
        };
    }),

    /**
     * @returns {this} The callee for chaining.
     * @public
     */
    start: function() {
        var $view = this.view,
            authPromise,
            i18nPromise,
            l10nPromise,
            themePromise,
            routerPromise;

        // Don't start more than once
        if (this.started !== -1) {
            return this;
        }

        // Mark application as starting
        this.set("started", 0);

        // Show loading graphic
        $view.requestShowLoadingGraphic();

        // Register Service Worker
        if ("serviceWorker" in navigator
            && (window.location.protocol === "https:" || window.location.hostname === "localhost")) {
            serviceWorkerRuntime.register()
                .catch(function(error) {
                    logger.error(error);

                    if (typeof Sentry !== "undefined" && error instanceof Error) {
                        Sentry.captureException(error);
                    }
                });
        }

        // Let's render the main view.
        this.render();

        // Load CMP
        this.$.privacyService.start();

        // Configure header to refresh on language change.
        this.observe("$.i18nService.translation", this.refreshHeader);

        // Initial user authentication
        this.observe("$.authService.isLoggedIn", this.onLoginStateChange);
        authPromise = this.$.authService.updateStatus();

        // Resolve locale
        i18nPromise = authPromise.then(this.bindSafely(function() {
            return this.$.i18nService.resolveLocale(
                this.$.router.getCurrentPathname(),
                this.$.authService.get("user")
            );
        }));

        // Resolve location
        l10nPromise = this.$.l10nService.resolveCountry();

        // Setup theme vars for initial viewport
        themePromise = new Promise(this.bindSafely(function(resolve) {
            themeVars.reflow();
            resolve();
        }));

        // Clear caches on auth change to prevent privilege escalation.
        domain.forEach(this.bindSafely(function(services) {
            services.set("authService", this.$.authService);
        }));

        // Setup the router
        routerPromise = new Promise(this.bindSafely(function(resolve) {
            var $router = this.$.router;

            // Register routes
            routes.forEach(function(route) {
                $router.addRoute(route);
            });

            // All routes added
            resolve();
        }));

        // Once we're all set up, we can handle the current route
        Promise
            .all([authPromise, i18nPromise, l10nPromise, themePromise, routerPromise])
            .then(this.bindSafely(function() {
                this.view.requestHideLoadingGraphic();
                this.set("started", 1);
                this.$.router.start();
            }))
            .catch(this.bindSafely(function(error) {
                logger.error(error);

                if (typeof Sentry !== "undefined" && error instanceof Error) {
                    Sentry.captureException(error);
                }

                // Hide loading graphic
                this.view.requestHideLoadingGraphic();
                this.set("started", 1);
            }));

        // Return the app instance, just like the normal app would.
        return this;
    },

    /**
     * @param  {int}  wasLoggedIn  Whether the user was logged in before
     * @private
     */
    onLoginStateChange: function(wasLoggedIn) {
        var $authService = this.$.authService,
            isLoggedIn   = $authService.isLoggedIn;

        // User just became logged-in
        if (wasLoggedIn !== 1 && isLoggedIn === 1) {
            // If user is in a pending state, meaning they have only progressed
            // partly through the registration process.
            if ($authService.user.status === "pending") {
                // We don't want to enter signup flow in IOS app, so instead we
                // log out the pending user.
                if (isIosApp) {
                    $authService.logout();
                }

                // In all other scenarios, we offer the user the option to
                // continue the signup process.
                else {
                    this.showContinueSignUpPopup();
                }
            }
        }

        // User became logged-out
        if (wasLoggedIn !== -1 && isLoggedIn === -1) {
            if ($authService.isAdult() === null
                && get(config, "ageVerification.enabled", false)) {
                this.showIsAdultPopup();
            }
        }
    },

    /**
     * @private
     */
    showContinueSignUpPopup: function() {
        var popup = this.$.continueSignUpPopup;

        if (!popup.hasNode()) {
            popup.set("canGenerate", true);
            popup.render();
        }
        popup.requestShow(true, true);
    },

    /**
     * @private
     */
    showIsAdultPopup: function() {
        var popup = this.$.isAdultPopup;

        if (!popup.hasNode()) {
            popup.set("canGenerate", true);
            popup.render();
        }
        popup.requestShow(true, true);
    },

    /**
     * @private
     */
    refreshHeader: function() {
        this.$.header.refresh();
    },

    /**
     * @private
     */
    handleResize: function() {
        themeVars.reflow();
    },

    // History navigation by `Esc` key.
    // --------------------------------

    /**
     * Counter to determine if navigation by `Esc` key is allowed.
     *
     * @private
     */
    navigateOnEscape: 1,

    /**
     * Prevent the application from navigating back to the previous route when
     * the user presses `Esc`.
     *
     * @public
     */
    blockNavigationOnEscape: function() {
        this.set("navigateOnEscape", this.get("navigateOnEscape") - 1);
    },

    /**
     * Allow the application to navigate back to the previous route when the
     * user presses `Esc`.
     *
     * @public
     */
    unblockNavigationOnEscape: function() {
        this.set("navigateOnEscape", this.get("navigateOnEscape") + 1);
    },

    /**
     * Pressing `esc` should navigate to the previous page unless:
     * - The user is closing a fullscreen element.
     * - The event is defaultPrevented.
     * - Navigation on `esc` is blocked.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The event
     * @returns  {boolean}       Whether to stop event propagation.
     * @private
     */
    handleKeyUp: function(sender, event) {
        // Do nothing if the event was already processed
        if (event.defaultPrevented) {
            return false;
        }

        // We only react to the `Esc` key.
        if (event.key !== "Escape" && event.keyCode !== 27) {
            return false;
        }

        // User is exiting fullscreen mode. No need to navigate as well.
        if (Control.Fullscreen.getFullscreenElement()) {
            return false;
        }

        // This feature has been blocked by another app component.
        if (this.get("navigateOnEscape") <= 0) {
            return false;
        }

        // Navigate back to previous page
        this.$.router.back();

        // Keystroke has been handled, no need to propagate further.
        return true;
    },

    // Destruction.
    // --------------------------------

    /**
     * @method
     * @private
     */
    destroy: kind.inherit(function(sup) {
        return function() {
            this.deactivatePage();
            this.deactivateMediaDetails();
            this.deactivateMediaPlayer();
            sup.apply(this, arguments);
        };
    })

});
